module.exports = __webpack_public_path__ + "static/media/BoxPlotQ7_1.e019130a.svg";